<div class="img-container">
  <img src="assets/img/404.jpg" alt="not found" loading="lazy" />
</div>
